import {
  MasterDataDTO,
  DivisionDTO,
  TaskDTO,
  IObjectDTO,
  BaseObjectDTO
} from './plyca-dtos';
import { ObjectContextDTO, ProcurementProjectLotDTO, ProjectEntityDTO, AwardDTO, ContractModificationDTO } from './plyca-dtos-v2';


export class FinanceDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  division: DivisionDTO;

  type: MasterDataDTO[];
  initialDate: Date;
  finalDate: Date;
  registrationDate: Date;
  concepts: ConceptDTO[];

  award: AwardDTO;
  contractModification: ContractModificationDTO;

  provisionNumber: any;
  payOrChargeWay: string;
}

export class IncomeDTO implements IObjectDTO<number> {
  identifier: number;
  task: TaskDTO;
  division: DivisionDTO;
  context?: ObjectContextDTO;
  project: ProjectEntityDTO;

  initialDate: Date;
  finalDate: Date;
  registrationDate: Date;

  taxIdentifier: string;

  provisionNumber: any;
}

export interface WorkFinanceProjectDTO extends BaseObjectDTO<string> {
  identifier: string;
  finance: FinanceDTO;
  context?: ObjectContextDTO;
}

export interface WorkIncomeDTO extends BaseObjectDTO<string> {
  identifier: string;
  income: IncomeDTO;
  context?: ObjectContextDTO;
}

export interface ConceptDTO extends BaseObjectDTO<string> {
  projectLot: ProcurementProjectLotDTO;
  amountYear1: number;
  amountYear2: number;
  amountYear3: number;
  amountYearRest: number;
  subType: MasterDataDTO;
}

export class TotalesDTO {
  type: String;
  total: number;
  year1: number;
  year2: number;
  year3: number;
  yearRest: number;
}

